import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardContain } from '../../style/Home'
import Filter from '../../Components/MvrFormFill'
import Grid from '@mui/material/Grid';
import { FormTabs, FormTabsContain } from '../../style/HO/MVRFormFill';
import { Tab, Tabs } from '@mui/material';
import DynamicAccordion from '../../Components/accordian/bmvrMomAccordian';
import { GetParameterData, MvrFormFillFieldData, MvrEvaluationData } from '../../services/bmvrMomFromFillService';
import { Loader } from "../../utils/loader";
import { TimeLineContain } from '../../style/timeline'
import "../../css/MVRFormFill.css";


const BmvrFormFill = () => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false);
  const [mvrFormParameter, setMvrFormParameter] = useState([]);
  const [formTab, setFormTab] = useState("");
  const location = useLocation();
  const row = location.state?.row;
  const [mvrFormData, setMvrFormData] = useState({});
  const [checkListData, setCheckListData] = useState([])
  const [parameterIndex, setParameterIndex] = useState(null)
  const [updateScore, setUpdateScore] = useState(Date.now())
  const [currPIndex, setCurrPIndex] = useState(1)

  const GetMvrFormParameter = async () => {
    try {
      setLoader(true);
      const evalRes = await MvrEvaluationData(row);
      const res = await MvrFormFillFieldData(row);
      if (res.success) {
        setMvrFormData(evalRes.data);
        const parameters = res?.data?.parameters ?? [];
        setMvrFormParameter(res.data.parameters)
        setFormTab(res?.data?.parameters[0].parameter)
        loadParameterData(parameters?.[0] ?? {} , 0)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false)
    }
  }

  const reFetchParameters = async() => {
      try {
        setLoader(true);
        const res = await MvrFormFillFieldData(row);
        if (res.success) {
          setMvrFormParameter(res?.data?.parameters ?? [])
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoader(false)
      }
    }

  useEffect(() => {
    const updateScore = async () => {
      try {
        const evalRes = await MvrEvaluationData(row);
        if (evalRes.success) {
          setMvrFormData(evalRes.data);
        }
      } catch (error) {
        console.error('Error updating score:', error);
      }
    };

    updateScore();
  }, []);



  const loadParameterData = async (parameter, index) => {
    try {
      if (parameter) {
        setCurrPIndex(index + 1)
        setLoader(true)
        const res = await GetParameterData( row, parameter?.parameterId )
        if (res.success) {
          setCheckListData(res.checklists)
          setParameterIndex(index)
        }
      }
    } catch (error) {
      console.log('error: ', error);
    } finally {
      setLoader(false)
    }
  }

  useEffect(() => {
    GetMvrFormParameter();
  }, [])

  const goToMoM = (e) => {
    e.preventDefault()
    navigate("/bmvr-mom-form", { state: { mvrData: mvrFormData } })
  }


  
const handleParameterScored = ({scoredParameterIndex=null, parameterScoredQuestions , parameterObtainedScore}) =>{
  if(scoredParameterIndex===null) return

  setMvrFormParameter(prevAry => {

    prevAry[scoredParameterIndex] = {
      ...prevAry[scoredParameterIndex], 
      scoredQuestions: parameterScoredQuestions, 
      obtainedScore: parameterObtainedScore
    }

    return prevAry;
  })
}

  return (
    <>
      {loader && <Loader fullScreen={true} />}
      <CardContain>
        <Card mt={1} className='Filter_bg StickyChild'>
          <Grid container spacing={1}>
            <Filter
            dealerCode ={row?.dealerCode}
            dealerName={row?.dealerName}
            city={row?.city}
            financialYear={row?.financialYear}
            period = {row?.period}
            frequency={row?.frequency}
            ></Filter>
          </Grid>
          <Grid container pt={2}>

            {mvrFormData?.evaluationTimeline && (
              <TimeLineContain>
                <div className="TimeLine">
                  <h4 className='TimeLineTitle'>Evaluation Timeline :</h4>
                  <h4 className='TimeLineTitle'>BMVR TABS:</h4>
                </div>
              </TimeLineContain>
            )}
          </Grid>
        </Card>
      </CardContain>
      <FormTabsContain mt={1}>
        <FormTabs className='Sticky'>
        <Tabs
            className='tascontain newcantain'
            value={formTab}
            onChange={(event, newValue) => setFormTab(newValue)}
            aria-label="tabs example">
            {
              mvrFormParameter.map((parameter, index) => (
                <Tab
                  onClick={() => loadParameterData(parameter, index)}
                  key={parameter.parameterId}
                  label={(<>
                  <span>
                    {parameter.parameter}
                  </span>
                  <p className="para_score">[{
                  parameter.scoredQuestions!==0 ?
                  parameter.obtainedScore : "_"
                  }/{parameter.totalScore}]</p>
                  </>
                )}
                  value={parameter.parameter}
                  className={parameter.totalQuestions <= parameter.scoredQuestions && parameterIndex!==index ? "bg-green" :
                    parameter.scoredQuestions!==0 && parameterIndex!==index ? "bg-yellow" :""}
                />
              ))
            }
          </Tabs>

        </FormTabs>
        <CardContain className='white_bg' sx={{ position: 'relative' }}>
          <Card className='p-0'>
            {checkListData?.length > 0 && (
              <DynamicAccordion
                mvrFormData={mvrFormData}
                checkListData={checkListData}
                setCheckListData={setCheckListData}
                setUpdateScore={setUpdateScore}
                currPIndex={currPIndex}
                parameterIndex={parameterIndex}
                handleParameterScored={handleParameterScored}
                reFetchParameters={reFetchParameters}
              />
            )}

          </Card>
        </CardContain>
      </FormTabsContain>
      <div onClick={goToMoM} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
        <button style={{ backgroundColor: '#4CAF50', color: 'white', border: 'none', padding: '10px 20px', fontSize: '14px', borderRadius: '5px', cursor: 'pointer' }}>
          Go to MOM &gt;&gt;
        </button>
      </div>

    </>
  )
}

export default BmvrFormFill